/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

/**
 * @implements {FirmwareManager}
 */
class GeneratorFirmwareManager {
  /** Vytvoří instanci. */
  constructor () {
    this.serialNumber = null;
    this.multiInstanceId = null;
  }

  /** @inheritdoc */
  getInfo () {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }

  /** @inheritdoc */
  getInterfaceVersion () {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }

  /** @inheritdoc */
  getManufacturer () {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }

  /** @inheritdoc */
  getModelName () {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }

  /** @inheritdoc */
  getSerialNumber () {
    return new Promise((resolve) => {
      const {serialNumber} = this;
      if (isNil(serialNumber)) {
        throw new Error('No serial number available.');
      }
      return resolve(serialNumber);
    });
  }

  /** @inheritdoc */
  getMultiInstanceId () {
    return new Promise((resolve) => resolve(this.multiInstanceId));
  }

  /** @inheritdoc */
  getVersion () {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }

  /**
   * @param {string} serialNumber Sériové číslo.
   * @returns {undefined}
   */
  setSerialNumber (serialNumber) {
    this.serialNumber = serialNumber;
  }

  /**
   * @param {string} multiInstanceId Sériové číslo.
   * @returns {undefined}
   */
  setMultiInstanceId (multiInstanceId) {
    this.multiInstanceId = multiInstanceId;
  }

  /** @inheritdoc */
  update (firmwareRelease) {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }
}

export default GeneratorFirmwareManager;
